import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';

import { IContext, primaryButton, input, dropdown, label, table, secondaryButton, surface, radioButtonGroup, radioButton } from 'msteams-ui-styles-core'

import { environment } from '../../environments/environment';

import { NotificationService } from '@progress/kendo-angular-notification'

import { AuthenticationProvider } from '../core/providers/authentication.provider';
import { MsTeamsContextProvider } from '../core/providers/msteamscontext.provider';

import { TeamRequestService } from '../core/services/team-request.service';

import { TeamRequest } from '../shared/models/team-request';
import { TeamRequestTypes } from '../shared/models/team-request-types';
import { OrganisationUnit } from '../shared/models/organisation-unit';
import { ApprovalUser } from '../shared/models/approval-user';
import { Team } from '../shared/models/team';
import { User } from '../shared/models/user';
import { Plant } from '../shared/models/plant';




@Component({
  selector: 'app-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.css']
})
export class NewRequestComponent implements OnInit {

  // props for layout  
  @Input() appContext: IContext;

  cssLabel: string;
  cssBtnPrimary: string;
  cssBtnSecondary: string;
  cssInput: string;
  cssDropdown;
  cssRadioLabel: string;
  cssRadio: string;

  isReady4Submitted = false;
  isOUNotSelected = true;

  opened = false;

  actualUser: string;

  // props for silent login
  graphClientId: string = environment.graphClientId;

  /*########### Form ###########*/
  newRequestForm = this._formBuilder.group({
    type: ['', [Validators.required]],
    nameSpecified: ['', [Validators.required]],
    description: ['', [Validators.required]],
    ou: [],
    approvalUserId: ['', [Validators.required]],
    owners: ['', [Validators.required]],
    members: [],
    extGuests: ['', [Validators.pattern(/^(?:(?!drschaer\.com|schaer\.com).)*$\r?\n?$/)]],
    plants: [],
    allowSharingWithExternals: [false]
  })

  public showIds: boolean = false;
  public enableValidation: boolean = false;

  public isTypeTPMPrj = false;

  // props for request form
  public teamRequestTypes: TeamRequestTypes[];

  public organisationUnits: OrganisationUnit[];
  public organisationUnitsFiltered: OrganisationUnit[];
  public organisationUnitSelected: OrganisationUnit;

  public approvalUsersFiltered: ApprovalUser[];
  public approvalUserSelected: number;

  public users: User[];
  public ownerFiltered: User[];
  public memberFiltered: User[];

  public allPlants: Plant[];
  public plantsFiltered: Plant[];
  public plantsSelected: Plant[];

  public similarTeams: Team[];

  public teamName: string = "Specify all required fields";

  public defaultOwner: User[];
  public defaultMember: User[];

  

  constructor(
    public _formBuilder: FormBuilder,
    private _msTeamsContextProvider: MsTeamsContextProvider,
    private _teamsRequestsService: TeamRequestService,  
    private _authenticationProvider: AuthenticationProvider,
    private _router: Router,
    private _route: ActivatedRoute,
    private _notificationService: NotificationService
  ) { }


  ngOnInit() {

    this._route.queryParamMap.subscribe(queryParams => {
      this.actualUser = queryParams.get("userPrincipal");
      console.log("userPrincipal:" + this.actualUser);
    })

    // Here is the magic.
    var context = this._msTeamsContextProvider.getContext();

    this.cssLabel = label(context);
    this.cssBtnPrimary = primaryButton(context);
    this.cssBtnSecondary = secondaryButton(context);
    this.cssDropdown = dropdown(context);
    this.cssRadioLabel = radioButton(context).label;
    this.cssRadio = radioButton(context).radio;
    this.cssInput = input(context).input;
  
    this.loadData();    
  }

  /* Getter method to access formcontrols */
  get type() { return this.newRequestForm.get('type'); }

  get nameSpecified() { return this.newRequestForm.get('nameSpecified'); }

  get description() { return this.newRequestForm.get('description'); }

  get ou() { return this.newRequestForm.get('ou'); }

  get approvalUser() { return this.newRequestForm.get('approvalUserId'); }

  get owners() { return this.newRequestForm.get('owners'); }

  get allowSharingWithExternals() { return this.newRequestForm.get('allowSharingWithExternals'); }

  get extGuests() { return this.newRequestForm.get('extGuests'); }

  get plants() { return this.newRequestForm.get('plant'); }

   // get data for the requestTeam form
  private loadData(): void {
        this._teamsRequestsService.getTypes().subscribe(data => {
            this.teamRequestTypes = data;
        });
        this._teamsRequestsService.getOrganisationUnits().subscribe(data => {
            this.organisationUnits = data;
            this.organisationUnitsFiltered = data;
        });
        this._teamsRequestsService.getUsers().subscribe(data => {
            this.users = data;
            this.ownerFiltered = data;
            this.memberFiltered = data;
            // set the DefaultOwner
          this.defaultOwner = data.filter((s) => s.mail && s.mail.toLowerCase().indexOf(this.actualUser.toLowerCase()) !== -1);
        });
    }
   
  // filters the OUs
  public filterChangeOU(searchTermOU: string): void {

    if (searchTermOU.length >= 1) {
      this.organisationUnitsFiltered = this.organisationUnits.filter((s) => s.name.toLowerCase().indexOf(searchTermOU.toLowerCase()) !== -1);
    }
    else {
      this.organisationUnitsFiltered = this.organisationUnits;
    }

  }

  // filters the Plants
  public filterChangePlants(searchTermPlants: string): void {
    
    if (searchTermPlants.length >= 1) {
      this.plantsFiltered = this.allPlants.filter((s) => s.displayName.toLowerCase().indexOf(searchTermPlants.toLowerCase()) !== -1);
    }
    else {
      this.plantsFiltered = this.allPlants;
    }

  }

  

  // gets the selected OU
  public valueOUChange(selectedOUDisplayName: OrganisationUnit): void {

    var selectedOU = this.organisationUnitsFiltered.filter((s) => s.displayName.toLowerCase().indexOf(selectedOUDisplayName.name.toLowerCase()) !== -1);

    if (selectedOU.length != 1) {
      return
    }

    this.isOUNotSelected = false;
    this.organisationUnitSelected = selectedOU[0];
    console.log("valueOUChange: " + selectedOU[0].displayName);   

    this._teamsRequestsService.getApprovalUsers(+this.organisationUnitSelected.id.toString()).subscribe(data => {

      this.approvalUsersFiltered = data;
      if (data) {
        this.approvalUserSelected = data[0].id;
      }

      this.updateTeamName();
    });   
  }


  public valuePlantChange(selectedOUDisplayName: OrganisationUnit): void {
      this.updateTeamName();
  }

  // filter the owner
  public filterChangeOwner(searchTermOwner: string): void {
    if (searchTermOwner.length >= 1) {
      this.ownerFiltered = this.users.filter((s) => s.displayName.toLowerCase().indexOf(searchTermOwner.toLowerCase()) !== -1);
    }
    else {
      this.ownerFiltered = this.users;
    }   
  }

  // filter the member
  public filterChangeMember(searchTermMember: string): void {
    if (searchTermMember.length >= 1) {
      this.memberFiltered = this.users.filter((s) => s.displayName.toLowerCase().indexOf(searchTermMember.toLowerCase()) !== -1);
    }
    else {
      this.memberFiltered = this.users;
    }
  }

 
  public changeType(): void {

    var type = this.newRequestForm.get('type').value;
    this.isTypeTPMPrj = (type.key == 'TPRJ');

    if (this.isTypeTPMPrj == false) {
      this.resetType();
    }
    else {
      // do some special handling for TPM
      this.populateTPMData();
    }


    // calculated the team name
    this.updateTeamName();
  }

  public updateTeamName() {

    if (this.isTypeTPMPrj) {

      if (this.newRequestForm.get('type').value != "" &&        
        this.organisationUnitSelected != undefined &&
        this.newRequestForm.get('nameSpecified').value != "" ) {

        if (this.newRequestForm.get('plants').value == null) {
          this.teamName = this.organisationUnitSelected.key +  '-' + this.newRequestForm.get('nameSpecified').value + '-' + this.newRequestForm.get('type').value.key;
        }
        else if (this.newRequestForm.get('plants').value.length == 1) {
          this.teamName = this.organisationUnitSelected.key + '-' + this.newRequestForm.get('plants').value[0].key + '-' + this.newRequestForm.get('nameSpecified').value + '-' + this.newRequestForm.get('type').value.key;
        }
        else {
          this.teamName = this.organisationUnitSelected.key + '-MANY-' + this.newRequestForm.get('nameSpecified').value + '-' + this.newRequestForm.get('type').value.key;
        }
        this.isReady4Submitted = true;
      }

    }
    else {

      if (this.newRequestForm.get('type').value != "" &&
        this.organisationUnitSelected != undefined &&
        this.newRequestForm.get('nameSpecified').value != "") {

        this.teamName = this.organisationUnitSelected.key + '-' + this.newRequestForm.get('nameSpecified').value + '-' + this.newRequestForm.get('type').value.key;
        this.isReady4Submitted = true;
      }

    }
    
  }

  public resetType() {
    this.defaultMember = null;
    this.organisationUnitSelected = null;
    this.approvalUsersFiltered = null;
    this.approvalUserSelected = null
    this.plantsSelected = null;
  }

  public populateTPMData() {

    // 1. set organisationUnit CORP-TPM as selected OU
    const CORP_TPM = "CORP - TPM";
    var selectedCORP_TPM = this.organisationUnits.filter((s) => s.name.toLowerCase().indexOf(CORP_TPM.toLowerCase()) !== -1)[0];
    this.valueOUChange(selectedCORP_TPM);

    this.isOUNotSelected = false;

    // 2. add COO to members
    this.defaultMember = this.users.filter((s) => s.mail && s.mail.toLowerCase().indexOf(environment.TPMResponsibleCOO.toLowerCase()) !== -1);

    // 3. show the plant selection
    this._teamsRequestsService.getPlant().subscribe(data => {
      this.allPlants = data;
      this.plantsFiltered = data;
    });
  }



  // submit and save the team request
  public submitAndSaveTeamRequest(): void {
    var teamRequest: TeamRequest = this.getForm();

    this._teamsRequestsService.save(teamRequest, this.similarTeams).then((result: any) => {

      // show success notification
      this.showSuccess();

      // Success
      this._router.navigate(['/'], { queryParams: { userPrincipal: this.actualUser } });

    }).catch((error: any) => {
      this.showError();
      console.error(error);
    });   
  }

  private showSuccess(): void {
    this._notificationService.show({
      content: 'The Team Request was successfully sent to the Organisation Unit Responible',
      hideAfter: 4000,
      animation: { type: 'fade', duration: 400 },
      type: { style: 'success', icon: true }
    });
  }

  private showError(): void {
    this._notificationService.show({
      content: 'The Team Request could not be sent to the Organisation Unit Responible',
      hideAfter: 4000,
      position: { horizontal: 'right', vertical: 'bottom' },
      animation: { type: 'fade', duration: 400 },
      type: { style: 'error', icon: true }
    });
  }

  private getForm() {
        var req = JSON.stringify(this.newRequestForm.value);
        var teamRequest: TeamRequest = JSON.parse(req);
        console.log(req);

        // set some attribute
        teamRequest.typeId = this.type.value.id;
        teamRequest.organisationUnitId = this.organisationUnitSelected.id;
        teamRequest.approvalUserId = +teamRequest.approvalUserId;
        teamRequest.name = this.teamName;
        teamRequest.creatorEmail = this._authenticationProvider.getCurrentUser();

        return teamRequest;
    }

  openConfirm() {

    this.enableValidation = true;

    if (this.newRequestForm.valid) {
      var teamRequest: TeamRequest = this.getForm();

      this._teamsRequestsService.getSimilars(teamRequest).subscribe(data => {
        this.similarTeams = data;
        this.opened = true;
      });
    }
  }

  cancel() {
    this._router.navigate(['/'], { queryParams: { userPrincipal: this.actualUser } });
  }

  OKConfirm() {   
      this.opened = false;
      this.submitAndSaveTeamRequest();
  }

  closeConfirm() {
    this.opened = false;
  }
}
